export default __webpack_public_path__ + "static/media/service.6bc69825.png";